import type { ThemeColor } from '@/types/blocks';
import { colors } from '@/theme/colors';

const LIGHT_PALETTE: Record<ThemeColor, string> = colors.chartSeries.light;
const DARK_PALETTE: Record<ThemeColor, string> = colors.chartSeries.dark;

const FALLBACK_COLORS = [
  LIGHT_PALETTE.primary,
  LIGHT_PALETTE.secondary,
  LIGHT_PALETTE.danger,
  LIGHT_PALETTE.accent_1,
  LIGHT_PALETTE.accent_3,
  LIGHT_PALETTE.neutral,
];

export const resolveColor = (
  token?: ThemeColor | null,
  isDark = false
): string => {
  if (!token) return isDark ? DARK_PALETTE.primary : LIGHT_PALETTE.primary;
  return isDark ? DARK_PALETTE[token] : LIGHT_PALETTE[token];
};

export const seriesColor = (
  index: number,
  token?: ThemeColor | null,
  isDark = false
): string => {
  if (token) return resolveColor(token, isDark);
  const palette = isDark ? Object.values(DARK_PALETTE) : FALLBACK_COLORS;
  return palette[index % palette.length];
};
